import { API_URL } from "config";
import Http from "util/https";
import { Order, ProductCdSearchParam, ProductSearchInfo, ProductSearchResponseApi } from "../types";


/**
 * 商品コード検索Api
 * @param params 検索条件パラメータ
 * @param clientCd 得意先コード
 * @returns ProductSearchInfo
 */
export default async function searchProductCdApi(params: ProductCdSearchParam, clientCd?: string): Promise<ProductSearchInfo[]> {
  const http = Http.default.alterAuth({useToken: true});
  const url = `${API_URL}/order/item/search`;
  const res = await http.post<ProductSearchResponseApi>(url, params);
  console.log(res);


  // const res: {data: ProductSearchResponseApi} = {data: [{
  //   product_cd: '000001',
  //   product_name: '商品1'
  // },{
  //   product_cd: '000002',
  //   product_name: '商品2'
  // },{
  //   product_cd: '000003',
  //   product_name: '商品3'
  // }]};

  const productInfoList: ProductSearchInfo[] = res.data.item_list.map((pInfo) => (
    {
      productCd: pInfo.item_cd ?? '',
      productName: pInfo.item_name ?? '',
      size: pInfo.size ?? '',
    }
  ));

  // await new Promise<void>((resolve) => {setTimeout(resolve, 1500)});

  return productInfoList;
}